function handleScroll() {
  if (document.querySelector(".quick-add-modal[open]")) return;

  const addTocartParent = document.getElementsByClassName("buy-buttons__wrapper")[0];
  const buyButtonsRef =
    addTocartParent?.querySelector(".product-form__buttons") ||
    addTocartParent?.querySelector(".product-form__submit");
  const stickyPanel = document.getElementById("stickyPanel");
  const mobStickypanel = document.getElementsByClassName("sticky-atc-mobile")[0];

  if (!buyButtonsRef) return;

  const buyButtonsRect = buyButtonsRef.getBoundingClientRect();

  const hasScrolledPast = buyButtonsRect.bottom < 0;

  if (hasScrolledPast) {
    stickyPanel?.classList.add("visible");
    mobStickypanel?.classList.add("visible");
    // Sync button state when sticky panel becomes visible
    setTimeout(() => {
      syncStickyAddToCartState();
    }, 100);
  } else {
    stickyPanel?.classList.remove("visible");
    mobStickypanel?.classList.remove("visible");
  }
}

// Function to sync sticky add-to-cart button state with main PDP
function syncStickyAddToCartState() {
  const mainAddToCartBtn = document.querySelector(".buy-buttons__wrapper .product-form__submit");
  const stickyAddToCartBtn = document.querySelector("#stickyPanel .product-form__submit");

  if (!mainAddToCartBtn || !stickyAddToCartBtn) return;

  if (mainAddToCartBtn.hasAttribute("hidden")) return;

  const updateButtonLabel = (button, text) => {
    if (!button || typeof text !== "string") return;
    const label = button.querySelector("span");
    if (label) {
      label.textContent = text;
    } else {
      const span = document.createElement("span");
      span.textContent = text;
      button.textContent = "";
      button.appendChild(span);
    }
  };

  // Copy button state from main PDP to sticky panel
  const isDisabled = mainAddToCartBtn.hasAttribute("disabled");
  const stickyIsLoading = stickyAddToCartBtn.classList.contains("product-form__submit--loading");
  const buttonText = mainAddToCartBtn.textContent || "";

  if (isDisabled) {
    stickyAddToCartBtn.setAttribute("disabled", "true");
  } else if (!stickyIsLoading) {
    stickyAddToCartBtn.removeAttribute("disabled");
  }

  // Update button text (clean up whitespace), but don't copy PDP's transient loading label.
  if (!stickyIsLoading) {
    const cleanButtonText = buttonText.trim();
    const addingText = (window.variantStrings?.adding || "").trim();
    if (!addingText || cleanButtonText !== addingText) {
      updateButtonLabel(stickyAddToCartBtn, cleanButtonText);
    }
  }

  // Check if button is hidden by parent elements
  const stickyFormButtons = document.querySelector("#stickyPanel .product-form__buttons");
  if (stickyFormButtons && !isDisabled) {
    stickyFormButtons.classList.remove("hide");
  }

  // Also handle mobile sticky panel
  const mobileStickyFormButtons = document.querySelector(".sticky-atc-mobile .product-form__buttons");
  if (mobileStickyFormButtons && !isDisabled) {
    mobileStickyFormButtons.classList.remove("hide");
  }

  // Clear back-in-stock content for available variants
  const stickyBackInStockButtons = document.querySelector("#stickyPanel .product-back-in-stock-buttons");
  if (stickyBackInStockButtons && !isDisabled) {
    stickyBackInStockButtons.innerHTML = "";
  }
}

// Handle sticky dropdown variant changes
document.addEventListener("DOMContentLoaded", function () {
  // Sync sticky button state on page load
  setTimeout(() => {
    syncStickyAddToCartState();
  }, 500);

  // Watch for changes in the main PDP button
  const mainAddToCartBtn = document.querySelector(".buy-buttons__wrapper .product-form__submit");
  if (mainAddToCartBtn) {
    const observer = new MutationObserver(() => {
      const stickyPanel = document.getElementById("stickyPanel");
      if (stickyPanel && stickyPanel.classList.contains("visible")) {
        syncStickyAddToCartState();
      }
    });

    observer.observe(mainAddToCartBtn, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  // Listen for clicks on sticky dropdown options
  document.addEventListener("click", function (event) {
    const stickyPanel = document.getElementById("stickyPanel");
    if (!stickyPanel) return;

    const target = event.target;
    const isStickyDropdownOption = target.classList.contains("product-dropdown-swatch") && stickyPanel.contains(target);

    if (isStickyDropdownOption) {
      const variantId = target.dataset.id;
      if (!variantId) return;

      // Find the variant data from the main product data
      const productDataElement = document.querySelector("[pdp-data-selected-variant]");
      const productData = productDataElement?.innerHTML;
      const parsedProductData = productData ? JSON.parse(productData) : {};

      const variant = parsedProductData.variants.find((v) => v.id == variantId);
      if (!variant) return;

      // Check if variant is out of stock, notify me, or waitlist enabled
      const isOutOfStock =
        !variant.available ||
        variant.metafields?.custom?.variant_online === false ||
        (variant.inventory == 0 && variant.metafields?.custom?.backInStock === "true");

      // Check if variant has waitlist enabled
      const isWaitlistEnabled =
        variant.metafields?.custom?.enableWaitlist === true || variant.metafields?.custom?.enableWaitlist === "true";

      if (isOutOfStock || isWaitlistEnabled) {
        // Hide sticky panel
        stickyPanel.classList.remove("visible");
        const mobStickypanel = document.getElementsByClassName("sticky-atc-mobile")[0];
        mobStickypanel?.classList.remove("visible");

        // Scroll to top of product detail page
        const productPage = document.querySelector(".product-page");
        if (productPage) {
          productPage.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          // Fallback to scroll to top of page
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      } else {
        // Sync button state for available variants
        setTimeout(() => {
          syncStickyAddToCartState();
        }, 100);
      }
    }
  });

  // Listen for variant changes from main PDP to sync sticky button state
  document.addEventListener("click", function (event) {
    const target = event.target;
    const isMainPDPVariant =
      (target.classList.contains("product-square-swatch") || target.classList.contains("product-dropdown-swatch")) &&
      target.closest(".product-page");

    if (isMainPDPVariant) {
      // Sync sticky button state after main PDP variant change
      setTimeout(() => {
        syncStickyAddToCartState();
      }, 100);
    }
  });
});

// Attach to scroll
window.addEventListener("scroll", () => handleScroll());
